import PropTypes from 'prop-types';
import React from 'react';
import { ATTRIBUTION_MODE_CHERRYPICK } from '../../../contexts/AbstractContext';
import { JobContextProvider } from '../../../contexts/JobContext';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import Pixel from '../../Analytics/VisibilityPixel/VisibilityPixel';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import ListSection from '../../Layout/ListSection/ListSection';
import { PurpleButton } from '../../LeftRail/CommonBox/CommonBox';
import { LOGIN_LAYOUT } from '../../Login/LoginLayoutComponent/Layouts/LogInLayout/constants';

import JobListing from '../../JobV3/Elements/JobListing/JobListing';

import './JobsBox.scss';

const svg = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="105"
        height="130"
        viewBox="0 0 105 130"
    >
        <g fill="none" fillRule="evenodd">
            <path
                fill="#3E3232"
                d="M34.387 6.484c.476 2.296.696 4.662.875 6.06.16 1.247.268 2.505.022 3.729-.246 1.224-.89 2.412-1.948 3.065-.651.396-1.417.582-2.178.64-2.742.222-3.855-1.328-6.087-2.225-2.37-.956-4.981-.513-7.352-1.865-2.967-1.7-1.002-5.034-.087-7.364 1.039-2.634.109-5.838 3.1-7.4C23.14-.134 25.608.274 28.22.064c1.014-.082 2.058-.164 3.011.291 1.659.78 2.589 3.403 3.156 6.13"
            />
            <path
                fill="#89725C"
                d="M15.875 128.127c-1.576-.195-2.998-2.35-3.946-3.39-.606-.663-2.033-1.606-2.197-2.487-.08-.434.153-1.009.367-1.557.123-.32.22-.638.297-.878.654-2.047 1.457-16.134 1.681-18.226.936.343 5.728-1.132 7.637-.835l-5.316 16.873c-.04.114-.27 1.049-.69 2.804a125.11 125.11 0 0 1 1.436 3.134c.152.354.69 1.205 1.065 2.108.609 1.464.95 3.037-.292 2.889"
            />
            <path
                fill="#8E9DB9"
                d="M16.044 128.562c-1.608-.194-3.166-2.605-4.134-3.64-.618-.66-2.01-1.762-2.177-2.638-.083-.432.125-1.024.343-1.57a22.985 22.985 0 0 0 5.07 5.186c.245.182.6.353.836.171.122-.102.162-.273.266-.387.622 1.456 1.063 3.026-.204 2.878"
            />
            <path
                fill="#89725C"
                d="M25.535 127.13c.868-.428 2.681-1.024 3.166-1.79.241-.382.244-1.001.219-1.575-.015-.327-.039-.653-.033-.9.054-2.117.31-15.488.827-17.503-1.09.011-5.537-2.881-7.624-3.22 1.77 10.834 2.713 16.83 2.83 17.987.088.873.061 3.363-.628 4.038-.285.281-1.526 1.587-2.243 2.296-.868.856 2.129 1.331 3.486.667z"
            />
            <path
                fill="#8E9DB9"
                d="M25.414 127.32c.803-.443 3.003-1.204 3.38-2.015.264-.57.154-1.678.088-2.008-1.97 1.468-3.52 2.884-5.846 3.653-.292.105-.683.163-.843-.105-.081-.128-.063-.303-.125-.443-1.064 1.2-2.547 2.613-.763 2.843 1.576.338 2.855-1.238 4.11-1.925z"
            />
            <path
                fill="#F8E683"
                d="M29.733 89.841c-.29-2.816-1.155-5.895-.981-8.7.1-1.62.203-3.194.916-4.767 2.129-4.687 2.642-9.899 3.677-14.905a97.717 97.717 0 0 0-1.101 6.397c.293-2.132.837-4.219 1.09-6.363a.878.878 0 0 1 .324-.593c.635-3.945.787-7.868-3.224-8.61-1.653-.307-19.722-.136-19.722.274a20.651 20.651 0 0 0-.265 7.059c.024 3.524-1.094 7.025-.311 10.537l3.823 19.785c-.42 2.566-1.138 5.086-1.996 7.584-1.125 5.496-3.923 15.809-3.677 16.398.246.59 4.072.502 5.603.673.544.057 1.143.103 1.593-.194.394-.273.572-.741.728-1.186 1.509-4.299 3.02-8.61 4.528-12.909l1.35 14.29c1.624.877 6.75.17 7.944-1.107 1.15-1.243.162-9.385.173-11.29.025-4.128-.05-8.256-.472-12.373l-7.645-21.17"
            />
            <path
                fill="#F7F7F7"
                d="M8.633 51.483a52.178 52.178 0 0 0 24.063 2.304c.022-11.497 2.19-23.43-1.927-34.155-.484-1.267-3.915-2.408-5.158-2.949-.57-.253-1.213-.288-1.83-.23-3.28.334-5.582 3.317-7.243 6.15a65.021 65.021 0 0 0-6.94 17.015c-.718 2.88-1.24 5.817-1.305 8.778a28.84 28.84 0 0 0 .184 3.95l.156-.863"
            />
            <path
                fill="#DFE5F2"
                d="M51.712 30.61c-.67 1.892-.94 3.189-1.667 4.545-1.81 3.385-5.737 10.553-9.797 9.083-3.086-1.128-4.487-4.296-4.615 1.664-.114 5.413.14 10.895.376 16.308.037.82.07 1.652-.185 2.427-.254.775-.934 1.368-1.836 1.824-1.593.809-3.876 1.196-5.701 1.39-.75.08-1.046-.65-.803-1.367 1.448-4.251 4.279-8.57 4.279-12.958v-.103c0-.638-.25-1.299-.23-1.971.086-2.906.06-6.017-.366-8.707-1.112-7.043-.1-13.539-1.212-20.57-.139-.878-.507-3.887-2.324-4.114-.79-.092-1.77.58-2.06.205-.283-.365-.769-.65-1.317-.832-.788-.274-1.73-.342-2.47-.16a2.532 2.532 0 0 0-.442.16l-.258.137-.017.01-.004.012c-6.04 8.023-4.695 22.11-7.487 33.266-.058.24-.122.467-.188.707-.044.17-.092.342-.142.501-.07.25-.142.49-.215.73-.605 2.005-1.3 4.057-1.563 6.074l-.013.091c-.22 1.766.022 3.727.435 5.607a1.731 1.731 0 0 1-2.056 2.063c-1.734-.376-3.699-.707-4.226-.9a13.124 13.124 0 0 1-1.104-.48c-.917-4.695 1.119-9.299-.728-13.675.047-.786-1.116-2.074-1.424-3.1-.812-2.735-.79-5.23-1.637-7.818-1-3.042.81-6.29 2.457-8.718 4.556-6.735 7.793-11.18 15.005-14.906a12.247 12.247 0 0 1 2.91-1.026c.438-.102.882-.17 1.323-.216a11.09 11.09 0 0 1 2.534-.012c1.088.103 2.157.365 3.175.764a11.7 11.7 0 0 1 4.294 2.917c4.647 4.946 7.4 9.14 9.927 15.465 2.099-.057 4.616-4.524 5.73-5.869.267-.33.538-.661.815-.98.978-1.128 2.058-2.2 3.343-2.872a.727.727 0 0 1 1.058.661c-1.724 1.21-1.062 3.307-1.574 4.743z"
            />
            <path
                fill="#B5BDD5"
                d="M35.155 33.818a11.59 11.59 0 0 0-.686-3.468c-.512-1.422-.667-2.856-.751-4.393-.017-.324-.45-.324-.432 0 .069 1.248.139 2.508.483 3.688.199.693.497 1.329.676 2.034.179.694.244 1.41.278 2.139.136 2.924.184 5.86.273 8.796.01.324.442.324.432 0-.09-2.936-.136-5.872-.273-8.796M4.129 50.827c-.244-.19-.61.11-.365.308 1.52 1.185 2.918 1.969 4.917 2.426.32.08.457-.338.137-.418-1.916-.438-3.233-1.182-4.69-2.316zM10.602 37.076c.64-.8 1.28-1.611 1.918-2.422.214-.267-.294-.522-.507-.255-.71.904-1.42 1.796-2.13 2.7-.522.649-1.37 1.402-1.56 2.213-.175.73.312 1.576.554 2.26.388 1.078.775 2.167 1.164 3.257.112.301.678.173.566-.14-.313-.88-.628-1.76-.943-2.642-.295-.823-1.078-2.132-.623-2.966.382-.707 1.052-1.356 1.56-2.005"
            />
            <path
                fill="#89725C"
                d="M12.509 53.013c.802.974.927 2.367.628 3.59-.299 1.223-.966 2.321-1.625 3.397a23.732 23.732 0 0 1-2.946-6.149c-.176-.566-.333-1.155-.263-1.755.045-.393.34-.804.886-1.235 1.071.782 2.472 1.133 3.32 2.152zM23.837 10.198c-.482-.414-.71-1.124-.428-1.67.283-.556 1.14-.807 1.645-.425.428.327.606 1.026 1.16 1.048.28.01.498-.175.665-.404l.015-.011.01-.011a8.184 8.184 0 0 0 1.423-1.561 6.865 6.865 0 0 0 1.37-3.056c.056-.328.084-.666.065-1.005a4.361 4.361 0 0 0-.053-.96c.442.524 1.168 1.484 1.526 2.314 1.31 3.089 2.122 6.658.178 9.857a1.46 1.46 0 0 1-1.411.676h-.01a22.707 22.707 0 0 1-6.19-1.571c.787-.546 1.663-1.43 1.211-2.25-.243-.436-.788-.643-1.176-.97"
            />
            <path
                fill="#89725C"
                d="M25.555 12.143s-.78 1.091-1.832 2.52a.852.852 0 0 1-.07.44 62.045 62.045 0 0 0-1.666 4.087c-.474 1.312.402 2.728 1.741 2.821l1.721.128c.9.058 1.73-.511 2.023-1.405l2.242-6.78-4.16-1.811"
            />
            <path
                fill="#3E3232"
                d="M25.39 11.164c.084 1.64.032 3.281-.156 4.921-.041.362-.095.736-.301 1.041-.558.837-1.895.826-2.942.6a14.302 14.302 0 0 1-4.083-1.607c-.916-.531-1.841-1.346-1.76-2.33.1-1.233 1.617-1.878 2.904-2.263 1.915-.577 3.999-1.154 5.908-.565l.43.203"
            />
            <path
                fill="#89725C"
                d="M52.571 26.466c-.033 1.316-.387 2.794-.886 4.248-1.373-.288-2.735-.923-3.4-2.009.953-1.143 2.005-2.228 3.256-2.909.477-.254 1.041.116 1.03.67"
            />
            <path
                fill="#89725C"
                d="M55.672 22.143c.06.448.012.907-.142 1.333 1.629.179 3.281.156 4.899-.079-.131.963-.975 1.68-1.772 2.307-1.154.919-2.39 1.87-3.876 2.094-.833.135-1.7.023-2.521-.179-.476-.112-.963-.257-1.308-.593-.345-.336-.476-.896-.179-1.266 1.729-2.083 3.361-3.289 4.9-3.617z"
            />
            <path
                fill="#E3C2B8"
                d="M73.701 107.427a8.59 8.59 0 0 0-2.102.046c.545 4.12 1.034 8.253.83 12.317a2.12 2.12 0 0 1 0 .537c-.08.776-.092 1.724-.262 2.466a3.41 3.41 0 0 1-.205.685c-.216.536-.522 1.016-.909 1.495a5.22 5.22 0 0 1-.318.377l-.102.114-.205.228c-.238.274-.522.605-.784.936-.92 1.153-1.704 2.478-.523 2.706 1.5.285 3.5-1.496 4.625-2.17.728-.433 2.25-1.05 2.614-1.814.193-.377.148-.97.08-1.541-.012-.126-.034-.252-.046-.366l-.011-.16c-.012-.125-.034-.25-.034-.353-.103-2.067.159-3.733.466-5.708l.022-.137c.41-2.866.557-5.777.603-8.688-1.216-.502-2.489-.845-3.739-.97"
            />
            <path
                fill="#EAC9EF"
                d="M76.36 125.35c-.364.765-1.886 1.381-2.614 1.815-1.125.673-3.125 2.454-4.625 2.169-1.181-.228-.397-1.553.523-2.706.262-.33.546-.662.784-.936l.205-.228.102-.114a5.22 5.22 0 0 0 .318-.377c.387-.48.693-.959.91-1.495a11.418 11.418 0 0 1 2.181-.297c.762-.046 1.602-.012 2.25.262.012.114.034.24.046.366.068.57.113 1.164-.08 1.54"
            />
            <path
                fill="#E3C2B8"
                d="M84.951 107.176a7.924 7.924 0 0 0-1.966.628c1.67 3.87 3.284 7.762 4.239 11.77.068.16.113.342.147.536.148.776.398 1.69.444 2.466.022.25.022.49 0 .73-.046.583-.205 1.13-.444 1.713-.034.114-.113.262-.193.456l-.068.137-.125.274c-.148.343-.33.73-.477 1.142-.546 1.381-.92 2.9.261 2.774 1.5-.137 2.887-2.443 3.773-3.413.557-.628 1.83-1.656 1.966-2.5.057-.423-.148-.994-.364-1.53-.057-.114-.102-.229-.148-.343l-.056-.148a3.565 3.565 0 0 1-.137-.343c-.67-1.974-.886-3.675-1.159-5.685l-.023-.137c-.409-2.922-1.079-5.799-1.852-8.653a13.31 13.31 0 0 0-3.818.126"
            />
            <path
                fill="#EAC9EF"
                d="M92.508 123.889c-.137.844-1.41 1.872-1.966 2.5-.886.97-2.273 3.276-3.773 3.413-1.182.125-.807-1.393-.261-2.774.148-.411.33-.8.477-1.142l.125-.274.068-.137c.08-.194.16-.342.193-.456.24-.583.398-1.13.444-1.713.602-.365 1.284-.662 1.977-.913.716-.251 1.511-.457 2.204-.377.046.114.091.229.148.343.216.536.42 1.107.364 1.53"
            />
            <path
                fill="#C4B8D6"
                d="M92.951 57.015c.023-.468.011-1.016-.352-1.313-.33-.286-.807-.24-1.216-.171-6.83.981-13.67 1.975-20.5 2.968-4.66 16.895-2.477 35.263-.114 53.038.227 1.666.489 3.436 1.455 4.817.909.354 1.92.457 2.852.457 1.295 0 2.67-.194 3.841-.73-.091-14.522.386-16.314-.193-24.979 1.716 7.135 4.375 17.067 6.09 24.19.137.583.194.89.262 1.062a.953.953 0 0 1 .648.206c1.363 1.073 3.58-.172 4.716-.868.352-.228.727-.468 1.09-.73l.012-.023c.84-1.85.602-4.03.261-6.097a77.023 77.023 0 0 0-2.011-9.018c-.841-2.9-1.841-5.822-1.864-8.802-.022-2.317.557-4.577 1.091-6.803a153.608 153.608 0 0 0 3.932-27.204z"
            />
            <path
                fill="#566D96"
                d="M80.701 23.338c-3.477-1.267-7.943-.285-10.011 3.368-.807 1.415-1.17 3.07-1.523 4.703-1.25 5.822-2.489 11.724-4.852 17.147-1.296 2.956-2.932 5.799-4.444 8.664-2.102 3.996-3.977 8.048-4.386 12.558-.057.627-.045 1.347.284 1.769.762-.594 1.273-1.484 1.841-2.26.352-.48.818-.81 1.296-1.142.034-.114.068-.24.102-.365.227-.8.307-1.633.568-2.42.466-1.416 1.432-2.535 2.375-3.608.455-.525.92-1.061 1.375-1.598 3.489-4.11 6.795-8.528 8.58-13.802 1.181-3.482 1.636-7.18 2.443-10.776.807-3.608 2.034-7.26 4.386-9.886.66-.73 1.398-1.37 2.08-2.078l-.114-.274"
            />
            <path
                fill="#E3C2B8"
                d="M59.871 57.22c-2.102 3.996-3.977 8.048-4.386 12.558-.057.627-.045 1.347.284 1.769.762-.594 1.273-1.484 1.841-2.26.352-.48.818-.81 1.296-1.142.034-.114.068-.24.102-.365.227-.8.307-1.633.568-2.42.466-1.416 1.432-2.535 2.375-3.608.455-.525.92-1.061 1.375-1.598-1.307-.788-2.557-1.69-3.455-2.934"
            />
            <path
                fill="#566D96"
                d="M98.406 62.346c-.398-.582-.796-1.165-1.194-1.758-3.011-4.464-5.795-9.224-6.988-14.67-.773-3.595-.818-7.317-1.216-10.993-.398-3.664-1.216-7.432-3.262-10.308-.568-.8-1.227-1.519-1.829-2.306l.136-.252c3.603-.867 7.932.617 9.58 4.475.636 1.496.818 3.185.977 4.84.602 5.937 1.182 11.93 2.92 17.581.955 3.094 2.262 6.096 3.444 9.121 1.636 4.201 3.045 8.448 2.954 12.969-.011.753-4.716-7.523-5.522-8.7z"
            />
            <path
                fill="#E3C2B8"
                d="M100.644 68.67c.034.194.08.388.125.594.637 1.278 1.75 2.523 2.852 3.333.296-.25.421-.879.478-1.53.034-.342.045-.673.045-.981.057-2.01-.773-3.859-1.159-5.777-.432-2.146-1.216-4.2-2.011-6.233-1.034 1.13-2.387 1.895-3.762 2.512.398.593.796 1.176 1.194 1.758.806 1.176 1.647 2.386 1.954 3.847.16.81.16 1.655.284 2.477"
            />
            <path
                fill="#566D96"
                d="M89.928 26.557c-.92-1.575-2.261-2.98-3.795-4.018-3.432-2.34-8.114-2.557-11.42-.285-2.24 1.552-3.5 4.977-4.319 7.5-.92 2.808-1.398 5.765-1.602 8.744-.227 3.38-.125 6.77-.011 10.16.102 3.117.67 6.016 1.056 9.144.42 3.345 5.978 3.322 8.489 3.425 3.795.16 7.591-.502 11.011-1.975 1.512-.64 3.046-1.541 3.625-3.082.319-.868.296-1.838.273-2.786-.114-4.052-.239-8.105-.352-12.157-.148-5-.364-10.263-2.955-14.67"
            />
            <path
                fill="#E3C2B8"
                d="M75.496 21.751a20.212 20.212 0 0 0 2.512 7.272 1.46 1.46 0 0 0 2.25.354 34.299 34.299 0 0 0 5.784-6.838l-.17-.114c-1.966-1.347-4.296-2.067-6.523-1.735a6.734 6.734 0 0 0-2.193.696l.931-.537-2.59.902"
            />
            <path
                fill="#DDA276"
                d="M86.826 3.212c-2.364-1.233-4.784-.833-7.352-1.039-2.273-.194-3.716.56-4.625 1.884l.045.262c0 2.603.216 5.32 1.352 7.706 1.125 2.386 3.012 4.247 5.012 5.913.261.217.307.48.216.72.5.274 1.011.547 1.534.787 1-.33 2.034-.445 3.08-.593.102-4.327 2.818-8.197 2.965-12.478-.272-1.267-.784-2.409-2.227-3.162"
            />
            <path
                fill="#E3C2B8"
                d="M84.11 12.185c.477-.434.705-1.176.42-1.758-.272-.582-1.113-.845-1.613-.445-.42.353-.591 1.084-1.136 1.107-.273 0-.489-.194-.66-.434l-.01-.011h-.012A8.16 8.16 0 0 1 79.7 8.988a7.403 7.403 0 0 1-1.34-3.219 4.623 4.623 0 0 1-.069-1.05c-.011-.343 0-.685.057-1.016-.443.548-1.148 1.564-1.5 2.443-1.296 3.242-2.091 6.998-.182 10.377.284.49.83.776 1.386.708h.012c2.09-.24 4.159-.8 6.08-1.656-.774-.57-1.626-1.507-1.183-2.363.239-.468.773-.673 1.148-1.027"
            />
            <path
                fill="#E3C2B8"
                d="M78.644 15.94l2.818 8.209 6.432-.434a1.241 1.241 0 0 0 .875-2.032c-2.261-2.74-5.84-7.523-5.84-7.523l-4.285 1.78"
            />
            <path
                fill="#915A48"
                d="M88.383 19.023l.023.068c.102.217.238.434.409.64l-.444-1.45c-.045.251-.045.49.012.742"
            />
            <path
                fill="#DDA276"
                d="M89.394 17.356c0-.171 0-.342.012-.502-.262-1.667-.194-3.425-.194-5 0-2.215.125-4.715-.556-6.895a5.675 5.675 0 0 0-.864-.788c-.489 1.336-.239 4.498-.284 4.806-.33 2.1-1.489 3.596-3.443 4.132.306 1.2-.091 2.18-.955 3.048-.886.89-2.057 1.564-2.898 2.478-1.875 1.997-1.83 5.045.091 7.009.932.936 2.273 1.712 2.58 2.9.625 2.397-3.352 4.144-3.42 6.598-.046 1.906 2.51 3.345 4.84 3.208 2.33-.149 4.33-1.45 5.841-2.9 2-1.94 3.466-4.315 3.75-6.838.341-2.968-2.17-4.475-3.398-6.792a9.6 9.6 0 0 1-1.102-4.464"
            />
            <path
                fill="#8E9DB9"
                d="M72.178 32.071c.16-.297-.295-.57-.454-.262-1.16 2.203-1.58 4.634-1.943 7.077-.17 1.13-.25 2.192-.035 3.334.273 1.37.75 2.98-.409 4.087-.238.24.125.616.375.376 1.819-1.735.273-4.36.42-6.45.217-2.728.774-5.719 2.046-8.162"
            />
        </g>
    </svg>
);

const Wrapper = ({ children }) => <div>{children}</div>;

export default class JobsBox extends React.PureComponent {
    renderZeroState = (pageContext) => {
        const { openModal, clickTrigger } = this.props;
        const { isLoggedIn, wrapAuth } = pageContext;
        const buttonValue = 'Get started';

        return (
            <div className="zero-state">
                <div className="title">Personalize your jobs</div>
                <div className="svg">{svg}</div>
                <div className="description">
                    Get recommendations for recent and relevant jobs.
                </div>
                {!isLoggedIn()
                    ? wrapAuth(
                          'right-rail-jobs',
                          PurpleButton({
                              inputStyle: 'btn-style w-140',
                              value: buttonValue,
                          }),
                          { login_trigger: 'right-rail-jobs' },
                          null,
                          LOGIN_LAYOUT
                      )
                    : PurpleButton({
                          inputStyle: 'btn-style w-140',
                          value: buttonValue,
                          onClick: openModal,
                          metric: {
                              misc_event_count: 1,
                              misc_event_type: clickTrigger,
                          },
                      })}
            </div>
        );
    };

    buildPixelMetrics = () => {
        const { metrics } = this.props;

        return {
            misc_event_type: metrics.impression,
            impression: 1,
        };
    };

    renderFilledState = (pageContext) => {
        const { suggestedJobs, metrics, showTitleSection } = this.props;
        const JobsSection = showTitleSection ? ListSection : Wrapper;

        return (
            <React.Fragment>
                <JobContextProvider
                    content={suggestedJobs}
                    session={pageContext.pageProps.session}
                    attributionMode={ATTRIBUTION_MODE_CHERRYPICK}
                >
                    <JobsSection title="Jobs You May Like">
                        {suggestedJobs.map((job) => (
                            <JobListing
                                key={job.hash}
                                {...job}
                                showExpired={false}
                            />
                        ))}
                        {metrics.impression && (
                            <Pixel metrics={this.buildPixelMetrics()} />
                        )}
                    </JobsSection>
                </JobContextProvider>
                <a className="see-more-button" href="/jobs">
                    See More
                </a>
            </React.Fragment>
        );
    };

    render() {
        const { suggestedJobs } = this.props;
        return (
            <PageConsumer>
                {(pageContext) => (
                    <CommonCardShell>
                        <div className="component-RightRail-JobsBox">
                            {pageContext.isLoggedIn() &&
                            suggestedJobs.length > 0
                                ? this.renderFilledState(pageContext)
                                : this.renderZeroState(pageContext)}
                        </div>
                    </CommonCardShell>
                )}
            </PageConsumer>
        );
    }
}

JobsBox.propTypes = {
    suggestedJobs: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            hash: PropTypes.string,
            image: PropTypes.shape({
                alt: PropTypes.string,
            }),
            title: PropTypes.string,
            highlight: PropTypes.bool,
            location: PropTypes.string,
            url: PropTypes.string,
            originalApplyUrl: PropTypes.string,
            company: PropTypes.shape({
                id: PropTypes.number,
                url: PropTypes.string,
                name: PropTypes.string,
            }),
            companyLogo: PropTypes.shape({
                src: PropTypes.string,
                alt: PropTypes.string,
            }),
            review: PropTypes.shape({
                url: PropTypes.string,
                count: PropTypes.number,
                rating: PropTypes.number,
            }),
            active: PropTypes.number,
            // eslint-disable-next-line react/forbid-prop-types
            pixels: PropTypes.object,
            // eslint-disable-next-line react/forbid-prop-types
            comments: PropTypes.array,
            reactionBar: PropTypes.shape({
                liking: PropTypes.shape({
                    icon: PropTypes.string,
                    enabled: PropTypes.bool,
                    label: PropTypes.string,
                    active: PropTypes.bool,
                    showCount: PropTypes.bool,
                }),
                flagging: PropTypes.shape({
                    icon: PropTypes.string,
                    enabled: PropTypes.bool,
                    label: PropTypes.string,
                    active: PropTypes.bool,
                    showCount: PropTypes.bool,
                }),
                commenting: PropTypes.shape({
                    icon: PropTypes.string,
                    enabled: PropTypes.bool,
                    label: PropTypes.string,
                    active: PropTypes.bool,
                    showCount: PropTypes.bool,
                }),
                sharing: PropTypes.shape({
                    icon: PropTypes.string,
                    enabled: PropTypes.bool,
                    label: PropTypes.string,
                    active: PropTypes.bool,
                    showCount: PropTypes.bool,
                }),
            }),
        })
    ),
    // eslint-disable-next-line react/forbid-prop-types
    metrics: PropTypes.object,
    showTitleSection: PropTypes.bool,
    openModal: PropTypes.func,
    clickTrigger: PropTypes.func,
};

JobsBox.defaultProps = {
    clickTrigger: undefined,
    suggestedJobs: [],
    openModal: () => {},
    metrics: {
        clickTrigger: 'right-rail-get-started-click',
    },
    showTitleSection: true,
};
